<template>
  <div>
    <div class="relative" @click="() => isExpanded = true">
      <div :class="[ isExpanded ? '' : 'line-clamp-3' ]" :style="isExpanded ? {} : { '-webkit-line-clamp': lines }" ref="$content">
        <slot />
      </div>
      
      <ButtonLink class="mt-6" @click.stop="() => isExpanded = false" v-if="isClamped && isExpanded">
        {{ $t('actions.showLess') }}
      </ButtonLink>

      <div class="absolute bottom-0 right-0 font-medium flex cursor-pointer" v-if="isClamped && !isExpanded">
        <div class="bg-gradient-to-r w-16" :class="[ gradient ]" :style="gradientStyle" />
        <p class="pl-4" :class="[ bg ]" :style="bgStyle">
          
          <ButtonLink>
            {{ $t('actions.showMore') }}
          </ButtonLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  lines?: number
  gradient?: string
  gradientStyle?: { [key: string]: string }
  bg?: string
  bgStyle?: { [key: string]: string }
}>(), {
  lines: 3,
  gradient: 'from-light-100/0 to-light-100 dark:from-dark-800/0 dark:to-dark-800',
  gradientStyle: () => ({}),
  bg: 'bg-light-100 dark:bg-dark-800',
  bgStyle: () => ({})
})
const isExpanded = ref(false)

useKeepAlive({
  onStart: () => {
   setTimeout(() => onRefresh())
   setTimeout(() => onRefresh(), 500)
  }
})

const $content = ref()
const { height: contentHeight } = useElementSize($content)

const isClamped = ref(false)

const onRefresh = () => {
  isClamped.value = ($content.value?.scrollHeight - contentHeight.value) > 5
}

</script>